export default __webpack_public_path__ + "static/media/increase.81b37b5e.svg";